import React, { memo, useContext } from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import CssTransition from '../../components/Transition/CssTransition';
import { connect } from 'react-redux';

import {
    AboutUs,
    AboutUsText,
    AboutUsBody,
    AboutUsHeader as DefaultAboutUsHeader,
    CloseButton,
    OverlayBackground,
    AboutUsTitle
} from '../../components/Overlay/OverlayComponents';
import SubscribeForm from './SubscribeForm';
import { onSubscribeComplete } from '../../containers/Widget/actions';
import { cacheFormData } from '../../utils/formCaching/actions';
import ThemeContext from '../../utils/theming';

const AboutUsHeader = styled(DefaultAboutUsHeader)`
    justify-content: space-between;
`;

const Body = styled.div`
    overflow-y: auto;
    padding: 0 10px 0 0;
`;

const Overlay = props => {
    const theme = useContext(ThemeContext);
    const Logo = props.logoComponent;
    const AboutUsTextContent = props.aboutUsComponent;
    return (
        <CssTransition in={props.isVisible}>
            <OverlayBackground
                theme={theme}
                isVisible={props.isVisible}
                onClick={() =>
                    props.setOverlayVisible(
                        false,
                        undefined,
                        false,
                        props.isActionChoiceOverlay,
                        props.isVoteSmartOverlay
                    )
                }
            >
                <CssTransition in={props.isVisible}>
                    <AboutUs
                        isVisible={props.isVisible}
                        onClick={proxy => proxy.stopPropagation()}
                        transitionType={props.transitionType}
                    >
                        <AboutUsHeader>
                            <Logo
                                onClick={() => {
                                    if (props.isPetitionOverlay) {
                                        props.setOverlayVisible(
                                            false,
                                            undefined,
                                            false,
                                            props.isActionChoiceOverlay
                                        );
                                        setTimeout(() => {
                                            props.setOverlayPartnerVisible(
                                                true,
                                                undefined,
                                                false,
                                                props.isActionChoiceOverlay,
                                                false
                                            );
                                        }, 450);
                                    } else {
                                        props.setOverlayVisible(
                                            false,
                                            undefined,
                                            false,
                                            props.isActionChoiceOverlay
                                        );
                                    }
                                }}
                                logoUrl={
                                    props.isRockTheVote
                                        ? props.logo
                                        : props.aboutUsContent.logoUrl
                                }
                                isSmall={props.logoIsSmall || false}
                                marginBottom={'0'}
                            />
                            <CloseButton
                                onClick={() =>
                                    props.setOverlayVisible(
                                        false,
                                        undefined,
                                        false,
                                        props.isActionChoiceOverlay,
                                        props.isVoteSmartOverlay
                                    )
                                }
                            >
                                +
                            </CloseButton>
                        </AboutUsHeader>
                        <Body
                            isPartnerOrPublisherOverlay={
                                props.isPartnerOrPublisherOverlay
                            }
                        >
                            <AboutUsBody
                                noTitle={props.title === ''}
                                isEmailSubmitted={props.isEmailSubmitted}
                            >
                                <AboutUsTitle>
                                    {props.isRockTheVote ? props.name : props.title}
                                </AboutUsTitle>
                                <AboutUsText
                                    theme={theme}
                                    isMobileResolution={props.isMobileResolution}
                                    isRockTheVote={props.isRockTheVote}
                                    allowScroll={props.allowScroll}
                                >
                                    <AboutUsTextContent
                                        widgetId={props.widgetId}
                                        isVoteSmartOverlay={props.isVoteSmartOverlay}
                                        description={
                                            props.isRockTheVote
                                                ? props.description
                                                : props.aboutUsContent.description
                                        }
                                    />
                                </AboutUsText>
                            </AboutUsBody>
                            {props.subscribeForm && (
                                <SubscribeForm
                                    onSubmit={values => {
                                        props.cacheFormData(values);
                                        props.onSubscribeComplete(
                                            values,
                                            props.activeAction.type,
                                            null,
                                            null
                                        );
                                    }}
                                    isEmailSubmitting={props.isEmailSubmitting}
                                    isEmailSubmitted={props.isEmailSubmitted}
                                />
                            )}
                        </Body>
                    </AboutUs>
                </CssTransition>
            </OverlayBackground>
        </CssTransition>
    );
};
Overlay.propTypes = {
    aboutUsComponent: PropTypes.func.isRequired,
    aboutUsContent: PropTypes.object,
    activeAction: PropTypes.object,
    allowScroll: PropTypes.bool,
    cacheFormData: PropTypes.func.isRequired,
    description: PropTypes.string,
    isActionChoiceOverlay: PropTypes.bool,
    isEmailSubmitted: PropTypes.bool,
    isEmailSubmitting: PropTypes.bool,
    isMobileResolution: PropTypes.bool.isRequired,
    isPartnerOrPublisherOverlay: PropTypes.bool,
    isPetitionOverlay: PropTypes.bool,
    isRockTheVote: PropTypes.bool,
    isVisible: PropTypes.bool,
    isVoteSmartOverlay: PropTypes.bool,
    logo: PropTypes.string,
    logoComponent: PropTypes.func.isRequired,
    logoIsSmall: PropTypes.bool,
    name: PropTypes.string,
    onSubscribeComplete: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func,
    setOverlayVisible: PropTypes.func.isRequired,
    subscribeForm: PropTypes.bool,
    title: PropTypes.string.isRequired,
    transitionType: PropTypes.string.isRequired,
    widgetId: PropTypes.number
};

function arePropsEqual(prevProps, nextProps) {
    if (
        prevProps.isVisible !== nextProps.isVisible ||
        prevProps.opportunity !== nextProps.opportunity ||
        prevProps.isEmailSubmitted !== nextProps.isEmailSubmitted ||
        prevProps.isEmailSubmitting !== nextProps.isEmailSubmitting
    ) {
        return false;
    } else {
        return true;
    }
}

export default connect(
    state => ({
        isEmailSubmitting: state.widget.isEmailSubmitting,
        isEmailSubmitted: state.widget.isEmailSubmitted,
        isRockTheVote: state.widget.isRockTheVote,
        activeAction: state.widget.activeAction
    }),
    { onSubscribeComplete, cacheFormData }
)(memo(Overlay, arePropsEqual));
